var render, staticRenderFns
import script from "./email-index.vue?vue&type=script&lang=js"
export * from "./email-index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0106c11c')) {
      api.createRecord('0106c11c', component.options)
    } else {
      api.reload('0106c11c', component.options)
    }
    
  }
}
component.options.__file = "resources/assets/js/components/shared/placeholder/email-index.vue"
export default component.exports